import { Box, CircularProgress, Typography } from "@mui/material";
import { useAccessibleFarmerProgrammes } from "model/useDashboardQueries";
import InsightsSection from "./InsightsSection";
import { FarmerTable } from "./corporate/FarmerTable";

export function AccessibleFarmsInsights() {
  const { data: accessibleFarmers, isLoading } =
    useAccessibleFarmerProgrammes();

  const hasAccess = (accessibleFarmers?.length ?? 0) > 0;

  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        minHeight: "100%",
        paddingTop: "20px",
        paddingBottom: "20px",
        overflowX: "hidden",
      }}
    >
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
          <CircularProgress size={32} />
        </Box>
      ) : hasAccess ? (
        <InsightsSection title="Farmers">
          <FarmerTable />
        </InsightsSection>
      ) : (
        <Box sx={{ p: 4, textAlign: "center" }}>
          <Typography variant="body1" color="text.secondary">
            You don't have access to individual farmer data for your programme.
          </Typography>
        </Box>
      )}
    </Box>
  );
}
